import React from "react"
import { DragOverlay } from "@dnd-kit/core"
import { useDragIndex } from "../contexts/drag-context"
import type { ITableColumnsType } from "../types"

interface TableDragOverlayProps<T = any> {
    columns: ITableColumnsType<T>
}

export const TableDragOverlay = <T,>({ columns }: TableDragOverlayProps<T>) => {
    const { dragIndex } = useDragIndex()

    const activeColumn = columns.find((col) => col.key === dragIndex.active)

    return (
        <DragOverlay>
            <th style={{ backgroundColor: "gray", padding: 16 }}>{activeColumn?.title as React.ReactNode}</th>
        </DragOverlay>
    )
}
